<template lang="pug">
  div
    Row
      Col(:lg="24" :md="24")
        Card.dashBoardCard
          LineChartWrapper(
            :chartType="'waflinechart'"
            :chartDataSetLabel="[$t('dashboard.wafEventCount')]"
            :titleDisplay="false"
            :withCard="false"
            :chartHeight="320"
            :linePointRadius="[4]"
            :linePointHoverRadius="[8]"
            :linePointBackgroundColor="['white']"
            :linePointBorderWidth="[3]"
            :lineBorderColors="[colorScheme.darkYellow.border]"
            :linePointHoverBorderWidth="[5]"
            :linePointHoverBorderColor="['rgba(152, 202, 235, 0.5)']"
            :linePointHoverBackgroundColor="['white']" 
            :lineBackgroundGradientStops="[colorScheme.darkYellow.gradientStops]"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
          SingleNumWrapper(
            :class="showRawBtnStyle == 'iconBtn' ? 'underLineChartWrapper' : ''"
            :chartType="'wafsumnum'"
            :chartTitle="$t('dashboard.wafEventCount')"
            :withCard="false"
            :textInSingleLine="true"
            maxFontSize="26px"
            style="text-align: right;"
          )
    Row
      Col(:lg="8" :md="12")
        Card.dashBoardCard
          PieChartWrapper(
            :chartType="'waftypepiechart'"
            :chartTitle="$t('dashboard.wafEventTitleText')"
            :topNSize="5"
            :chartHeight="chartHeight"  
            :withCard="false"
            :pieBackgroundColors="[colorScheme.colorSets.fill]"
            :legendPosition="'right'"
            :legendAlign="'start'"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
      Col(:lg="16" :md="12")
        Card.dashBoardCard
          LineChartWrapper(
            :chartType="'edgewaftypelinechart'"
            :chartTitle="$t('dashboard.wafEventTitleText')"
            :useBackendDatasetLabel="true"
            :withCard="false"
            :chartHeight="400"
            :linePointRadius="[4]"
            :linePointHoverRadius="[8]"
            :linePointBackgroundColor="['white']"
            :linePointBorderWidth="[3]"
            :lineBorderColors="colorScheme.colorSets.border"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
    Row
      Col(:lg="8" :md="12")
        Card.dashBoardCard
          PieChartWrapper(
            :chartType="'sourceIpPieChartByWafCount'"
            :chartTitle="$t('dashboard.visitorIp')"
            :topNSize="5"
            :chartHeight="chartHeight"
            :withCard="false"
            :pieBackgroundColors="[colorScheme.colorSets.fill]"
            :legendPosition="'right'"
            :legendAlign="'start'"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )

      Col(:lg="16" :md="12")
        Card.dashBoardCard
          BarChartWrapper(
            :chartType="'servicegroupBarChartByWafCount'"
            :chartDataSetLabel="[$t('dashboard.serviceGroupNameText')]"
            :topNSize="3"
            :chartHeight="chartHeight"
            :withCard="false"
            :direction="direction"
            :barBorderColors="[colorScheme.blue.border]"
            :barBackgroundColors="[colorScheme.blue.fill]"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
    Row
      Col(:lg="8" :md="12")
        Card.dashBoardCard
          PieChartWrapper(
            :chartType="'countryPieChartByWafCount'"
            :chartTitle="$t('dashboard.countryText')"
            :topNSize="5"
            :chartHeight="chartHeight"
            :withCard="false"
            :pieBackgroundColors="[colorScheme.colorSets.fill]"
            :legendPosition="'right'"
            :legendAlign="'start'"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
      Col(:lg="16" :md="12")
        Card.dashBoardCard
          BarChartWrapper(
            :chartType="'domainBarChartByWafCount'"
            :chartDataSetLabel="[$t('dashboard.domainNameText')]"
            :topNSize="10"
            :chartHeight="chartHeight"
            :withCard="false"
            :direction="direction"
            :barBorderColors="[colorScheme.blue.border]"
            :barBackgroundColors="[colorScheme.blue.fill]"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
    Row
      Col(:lg="8" :md="12")
        Card.dashBoardCard
          BarChartWrapper(
            :chartType="'sourceIpBarChartByWafCount'"
            :chartDataSetLabel="[$t('dashboard.visitorIp')]"
            :topNSize="10"
            :chartHeight="chartHeight"
            :withCard="false"
            :direction="direction"
            :barBorderColors="[colorScheme.blue.border]"
            :barBackgroundColors="[colorScheme.blue.fill]"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
      Col(:lg="16" :md="12")
        Card.dashBoardCard
          BarChartWrapper(
            :chartType="'uriBarChartByWafCount'"
            :chartDataSetLabel="[$t('dashboard.uri')]"
            :topNSize="10"
            :chartHeight="chartHeight"
            :withCard="false"
            :direction="direction"
            :barBorderColors="[colorScheme.blue.border]"
            :barBackgroundColors="[colorScheme.blue.fill]"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
    Row
      Col(:lg="24" :md="24")
        Card.dashBoardCard
          BarChartWrapper(
              :chartType="'userAgentBarChartByWafCount'"
              :chartDataSetLabel="[$t('dashboard.userAgent')]"
              :topNSize="10"
              :chartHeight="chartHeight"
              :withCard="false"
              :direction="direction"
              :barBorderColors="[colorScheme.blue.border]"
              :barBackgroundColors="[colorScheme.blue.fill]"
              :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
              )
</template>
<script>
import LineChartWrapper from "@/components/dashboard/LineChartWrapper";
import BarChartWrapper from "@/components/dashboard/BarChartWrapper";
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";
import PieChartWrapper from "@/components/dashboard/PieChartWrapper";

import colorScheme from "@/data/colorScheme";

export default {
    components: {
        LineChartWrapper,
        BarChartWrapper,
        SingleNumWrapper,
        PieChartWrapper
    },
    props: {
        groupNames: {
            type: Array,
            default: () => []
        },
        serviceGroupNames: {
            type: Array,
            default: () => []
        },
        domains: {
            type: Array,
            default: () => []
        },
        origins: {
            type: Array,
            default: () => []
        },
        edgeNames: {
            type: Array,
            default: () => []
        },
        dateRange: {
            type: String,
            default: "1"
        },
        customTimeRange: {
            type: Array,
            default: () => ["", ""]
        },
        direction: {
            type: String,
            default: "vertical"
        }
    },
    data() {
        return {
            colorScheme: colorScheme,
            chartHeight: 280
        };
    },
    computed: {
        showRawBtnStyle() {
            return this.$store.getters.getChartConfig.showRawBtnStyle;
        }
    }
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/HomePage/WebProtectionContent.vue